<template>
    <img src="../../images/spinner-white.svg" alt="spinner">
</template>
